/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    standalone: false
})
export class BreadcrumbsComponent implements OnInit {
  breadcrumbs: { label: string; url: string }[] = [];

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.router.events.subscribe(() => {
      this.buildBreadcrumbs();
    });
  }

  // Builds the breadcrumbs based on the current path
  buildBreadcrumbs(): void {
    const segments = this.router.url.split('?')[0].split('/').filter((segment) => segment);

    let url = '';
    this.breadcrumbs = segments.map((segment, index) => {
      url += `/${segment}`;
      const label = this.formatLabel(segment);

      return { label, url };
    });
  }

  // Formats the label to make it more readable (e.g., 'users' -> 'Users')
  formatLabel(segment: string): string {
    return segment.charAt(0).toUpperCase() + segment.slice(1).replace('-', ' ');
  }
}
